import { IconButton, Tooltip, Typography } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import CopyIcon from '@material-ui/icons/FileCopy'
import { useState } from 'react'

import { getTranslate } from '../../localization'
import { ChannelAPIKeys } from '../../types/channelAPIKeys'
import useStyles from './index.styles'

interface UserAPIKeyRowProps {
  data: ChannelAPIKeys
  deleteFunction: (input: ChannelAPIKeys, index: number) => void
  pendingForDeletion: boolean
  currentID: string
  index: number
  hasAccessToModifyChannelApiKeys?: boolean | undefined
}
const UserAPIKeyRowMobile: React.FC<UserAPIKeyRowProps> = ({
  data,
  deleteFunction,
  pendingForDeletion,
  currentID,
  index,
  hasAccessToModifyChannelApiKeys
}) => {
  const classes = useStyles()
  const [toolTipIsOpen, settoolTipIsOpen] = useState(false)

  const copyAPIKey = () => {
    window.navigator.clipboard.writeText(data.key)
  }

  return (
    <div className={classes.tableRowMobile}>
      <div className={[classes.APIKeyCell, classes.APIKeyCellMobile].join(' ')}>
        <span>{data.key}</span>
        <Tooltip
          onClose={() => settoolTipIsOpen(false)}
          open={toolTipIsOpen}
          placement="left"
          title={getTranslate('Copied to Clipboard')}>
          <IconButton
            onClick={() => {
              copyAPIKey()
              settoolTipIsOpen(true)
            }}
            className={classes.copyIconButtonMobile}>
            <CopyIcon />
          </IconButton>
        </Tooltip>
      </div>
      <div className={classes.expireDateCellmobile}>
        <Typography variant="caption">{`${getTranslate(
          'Expires At'
        )}: `}</Typography>
        {data.expiresAt}
      </div>
      <div className={classes.descriptionCellmobile}>
        <Typography variant="caption">{`${getTranslate(
          'Description'
        )}: `}</Typography>
        {data.description}
      </div>
      <div className={classes.deleteIconCellMobile}>
        <IconButton
          size="small"
          className={classes.deleteButtonMobile}
          onClick={() => deleteFunction(data, index)}
          disabled={
            (pendingForDeletion && currentID === data.id) ||
            !hasAccessToModifyChannelApiKeys
          }>
          <DeleteIcon className={classes.deleteIconMobile} />
        </IconButton>
        {/* <Button variant="contained" color="primary">
          Delete this key
        </Button> */}
      </div>
    </div>
  )
}

export default UserAPIKeyRowMobile
